import { render } from "./PaperRecent.vue?vue&type=template&id=6e7c764e&scoped=true"
import script from "./PaperRecent.vue?vue&type=script&lang=js"
export * from "./PaperRecent.vue?vue&type=script&lang=js"

import "./PaperRecent.vue?vue&type=style&index=0&id=6e7c764e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7c764e"]])

export default __exports__